export default {
  lang: 'Português',
  homeScreen: {
    title: '',
    stayConnected: 'Mantenha-se conectado',
    comingSoon: 'Em breve',
    messages: 'Mensagens',
    subtitle: 'Live Boricua',
  },
  loginScreen: {
    title:
      'Treinamento de profissionais de viagens e programa de capacitação de vendas',
    emailPrompt:
      'Digite seu endereço de e-mail e senha para confirmar que você é um profissional de viagens.',
    newUser: 'Novo usuário',
    register: 'Registro',
    registered: 'Este e-mail já está registrado',
    forgot: 'Redefinir senha',
    header:
      'Reserve um momento para preencher todas as informações abaixo, pois é isso que preencherá seu perfil e suas informações de contato.',
    step1: 'Etapa 1: Preencha seu endereço de e-mail e escolha uma senha.',
    version2: {
      homeTitle:
        'Vamos ver se conseguimos encontrar um perfil existente para você em nosso sistema.',
      homeTitleSub:
        'Digite o endereço de e-mail que você normalmente usa para fazer login nos programas de treinamento.',
      noAccount:
        'Nenhuma conta encontrada ({email}), tente com outro e-mail ou crie uma conta agora.',
      continueButton: 'Continuar',
      success:
        'Sua conta foi atualizada com sucesso! Em breve, você será redirecionado para a página inicial.',
      successNewAccount:
        'Para concluir seu registro, você receberá um e-mail de confirmação para verificar sua conta.',
      loginButton: 'Login',
      matchFound:
        'Encontramos uma correspondência, preencha sua senha para continuar.',
      magicLink: 'Faça login por meio de um link em seu e-mail:',
      magicLinkButton: 'Solicitar Magic Link',
      magicLinkTitle:
        'Receba um link direto enviado para seu e-mail que o inscreverá instantaneamente.',
      otherEmailButton: 'Enviar',
      title:
        'Reserve um momento para preencher todas as informações abaixo, pois elas preencherão seu perfil pessoal e suas informações de contato.',
      titleIndustry:
        'Reserve um momento para preencher todas as informações abaixo, pois elas preencherão seu perfil pessoal e suas informações de contato.',
      register: 'Criar uma conta',
      agent: 'Consultor de viagens',
      visitor: 'Visitante do setor',
      step1: 'Etapa 1: Tipo de usuário',
      step2: 'Etapa 2: Criar uma conta',
      step3: 'Etapa 3: Crie seu perfil',
      marketingOptIn:
        'Tem certeza de que não está interessado em permanecer conectado à equipe de comércio de viagens deste programa?',
      optIn: 'Sim, estou interessado',
      optOut: 'Não estou interessado',
      step2Sub1: 'Conte-nos sobre você',
      step2Sub2: 'Conte-nos sobre sua empresa',
      privacyHead: 'PREFERÊNCIAS DE COMUNICAÇÃO',
      privacySub:
        'Marque as caixas abaixo para garantir que você receba comunicações importantes da equipe de comércio de viagens do fornecedor (atualizações e anúncios de produtos, recompensas, incentivos, FAMs, etc.) e iniciativas de suporte de vendas e rede de comércio de viagens do TravPRO Mobile.',
      privacy:
        'Protegemos sua privacidade e nunca vendemos, usamos indevidamente ou traímos sua confiança.',
      store: 'Baixe facilmente esse programa em sua loja de aplicativos:',
      powered: 'ALIMENTADO POR',
      toastMessage: {
        forgotSuccess:
          'Enviamos seu link de redefinição de senha por e-mail! Você será redirecionado para a página de login em 10 segundos.',
        emailNotExisting: 'O endereço de e-mail que você digitou não existe.',
        magicLinkMessage:
          'Aguarde, pois estamos fazendo seu login agora mesmo.',
        magicLinkError:
          'Não foi possível encontrar sua conta em nosso banco de dados, faça login manualmente. Você será redirecionado em 10 segundos.',
        magicLinkError1:
          'Não foi possível encontrar um token válido, faça login ou solicite um novo link mágico. Se o problema persistir, entre em contato conosco pelo e-mail: info@travpromobile.com.',
        magicLinkError2:
          'Não foi possível encontrar sua conta em nosso banco de dados, faça login manualmente. Você será redirecionado em 10 segundos.',
        magicLinkSuccess:
          'Verifique seu e-mail em {email}. Ele tem um link mágico que fará seu login.',
        magicLinkErrorWait:
          'Aguarde 5 minutos entre as solicitações de links mágicos.',
        emailNotFoundError:
          'O endereço de e-mail que você digitou não pode ser encontrado em nossos registros. Verifique se há erros de ortografia ou crie uma conta.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode não encontrado, tente novamente',
        zipCodeOnlyNumbers: 'O ZipCode só pode conter números',
        password: 'Digite uma senha',
        passwordNotMatching: 'As senhas inseridas não correspondem',
        passwordTooShort: 'A senha precisa ter pelo menos 8 caracteres',
        emailExists:
          'Este endereço de e-mail já existe ou é inválido. Tente usar outro endereço de e-mail ou faça login em sua conta.',
        fillInAllFields: 'Por favor, preencha todos os campos obrigatórios',
        fillInEmail: 'Por favor, preencha seu e-mail.',
        emailNotExisting: 'O endereço de e-mail que você digitou não existe.',
      },
      fields: {
        forgotSubCopy: 'Esqueceu sua senha e deseja alterá-la? ',
        forgotSubCopy2:
          'Deseja ignorar totalmente a senha? Nós lhe enviaremos um e-mail com um link mágico que fará seu login automaticamente no programa. ',
        city: 'Cidade',
        companyName: 'Nome da empresa',
        role: 'Sua função',
        description: 'O que melhor descreve os negócios de sua empresa?',
        country: 'País',
        password: 'Senha',
        passwordRegister: 'Escolha a senha (mínimo de 8 caracteres)',
        passwordConfirm: 'Confirmar senha',
        firstName: 'Primeiro nome (próprio)',
        lastName: 'Sobrenome (família)',
        agency: 'Nome de sua agência',
        title: 'Sua função (selecione uma)',
        company: 'Nome da empresa',
        select: 'Selecione uma opção abaixo',
        state: 'Estado',
        province: 'Província/Região/Estado',
        zipCode: 'Código Postal',
        postalCode: 'Código Postal',
        affiliate: 'Qual grupo é sua principal afiliação à agência?',
        hostAgency: 'Sua agência anfitriã?',
        executive: 'Executivo',
        management: 'Gerenciamento',
        marketing: 'Marketing',
        sales: 'Vendas',
        coordinator: 'Coordenador',
        other: 'Outros',
        opt: 'Mantenha-se conectado à equipe de comércio de viagens deste programa e receba atualizações.',
        optMarketing:
          'Mantenha-se conectado ao TravPRO com relação a programas e eventos semelhantes.',
        retail: 'Frente de loja de varejo',
        home: 'Agente em casa',
        independent: 'Empreiteiro independente',
        host: 'Agência anfitriã',
        call: 'Call center ou agência baseada na Web',
        describes: 'O que melhor descreve você e os negócios de sua agência?',
      },
    },
    welcome: {
      headerTop: 'Bem-vindo ao',
      headerBottom: '{program_name}',
    },
    sellingPoints: {
      0: 'Aprenda, promova e venda em qualquer lugar',
      1: 'Treinamento multimídia em vários dispositivos',
      2: 'Certificado de conclusão',
      3: 'Apresentações de vendas prontas',
      4: 'Materiais promocionais de alto impacto',
      5: 'Dicas e promoções privilegiadas',
      6: 'Diretório de produtos em tempo real',
      7: 'Notícias e atualizações oportunas',
    },
    tAndC: {
      agree: 'Ao continuar, você concorda com nossos ',
      privacyPolicy: 'política de privacidade ',
      and: 'e ',
      termsConditions: 'termos e condições',
    },
    fields: {
      what: 'Que tipo de viagem vocês vendem?',
      what1: 'Qual é o principal tipo de viagem que você vende?',
      what2: 'Qual é o segundo tipo de viagem que você vende?',
      what3: 'Qual é o terceiro tipo de viagem que você vende?',
      agency: 'Agência *',
      email: 'E-mail',
      password: 'Senha',
      passwordConfirm: 'Confirme sua senha *',
      firstName: 'Nome próprio *',
      lastName: 'Sobrenome *',
      agencyName: 'Nome da agência *',
      city: 'Cidade *',
      stateProvince: 'Estado / Província *',
      salutation: 'Saudação *',
      required: 'Necessário',
      invalidEmail: 'Endereço de e-mail inválido',
      opt: 'Fique em contato! Sim, gostaria de optar por receber comunicações do {client_name} que me manterão informado sobre notícias, eventos, incentivos, FAMs e muito mais!',
      complete: 'Etapa 2: Complete seu perfil',
      tell: 'Conte-nos sobre você',
      title: 'Título da empresa *',
      host: 'Nome da agência anfitriã',
      country: 'País / Região',
      select: 'Selecione uma opção abaixo',
      header2: 'Em que segmento(s) você vende principalmente?',
      step2: 'Descreva seu negócio',
      leisure: 'Lazer',
      corporate: 'Corporativo',
      group: 'Grupo',
      affiliate: 'Qual é sua principal afiliação?',
      forgot:
        'Esqueceu sua senha? Clique no botão abaixo e nós lhe enviaremos um e-mail para redefinir sua senha.',
    },
    noAgent: {
      noAgentButton: 'Não sou um consultor',
      title: 'Obrigado por seu interesse em\n{program_name}',
      messageWeb:
        'O conteúdo deste site é exclusivo para profissionais de viagens.\nPara saber mais sobre {program_name}, visite: ',
      messageMobile:
        'Alguns conteúdos deste aplicativo são exclusivos para profissionais de viagens, mas sinta-se à vontade para navegar por uma prévia do que este aplicativo tem a oferecer pressionando "Continuar".',
      continue: 'Continuar',
      visitWebsite: 'Visite o site',
    },
  },
  welcomeScreen: {
    title: 'Bem-vindo ao {program_name}',
    helloUser: 'Olá {{name}}',
    hello: 'Olá,',
    fromAgency: 'da {{agency}}',
    notUser: 'Não é {{name}}?',
    introOnline:
      'Treine imediatamente on-line ou faça o pré-carregamento do conteúdo para que ele esteja sempre disponível para uso off-line!',
    introOffline:
      'Você já tem a versão mais recente pré-carregada. Comece a treinar ou vender a qualquer hora, em qualquer lugar!',
    startTraining: 'Comece a aprender',
    continueTraining: 'Continuar aprendendo',
    graduated: 'Parabéns!',
    downloader: {
      preload: 'Pré-carga',
      stop: 'parar',
      init: 'Inicializando...',
      lastUpdate: 'Última atualização: ',
    },
  },
  trainingScreens: {
    start: 'Início',
    continue: 'Continuar',
    review: 'Revisão',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% Concluído',
    unlock:
      'Desbloqueie este capítulo ao concluir o capítulo de treinamento {number}.',
    unlockSpecialization:
      'Desbloqueie este capítulo ao concluir The Foundation',
    unlockSubtitle:
      'Desbloqueie mais capítulos ao concluir os capítulos de treinamento.',
    allUnlocked: 'Você desbloqueou todos os capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: 'Você chegou ao fim',
    retainEnd:
      'Use a barra superior para navegar neste capítulo ou pressione o botão Voltar para retornar à visão geral.',
    watchListenRead: 'Assista, ouça e leia mais',
    trouble:
      'Parece que você está tendo problemas. Releia o conteúdo da(s) página(s) anterior(es) e tente novamente.',
    confirm: 'Confirme sua resposta',
    choose: 'Escolha uma resposta',
    skip: 'Retornar >',
    viewAllTitle: 'Dica de treinamento',
    viewAll:
      'Para prosseguir para a próxima página, clique nos ícones para visualizar o conteúdo suplementar. Vídeos, mapas e outras informações úteis foram fornecidos para aprimorar seu treinamento e garantir que você alcance o status de PRO.',
    fillBlanks: 'Preencha o(s) espaço(s) em branco:',
    next: 'Próxima pergunta',
    retry: 'Tente novamente',
    fastTrack: 'Torne-se um Swiss Travel Superstar!',
    fastTrackExplanation:
      'Basta responder ao questionário nas páginas a seguir para ter a chance de ganhar um FAM para a Suíça!<br><br><span style="font-weight: bold">Você encontrará todas as respostas para as perguntas do questionário das seguintes maneiras:</span><br><br>1.\tO conteúdo que você aprendeu nos módulos Rail Europe e Switzerland<br><br>2. E nos seguintes sites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><br><span style="font-weight: bold">Não deixe de analisar esses recursos detalhadamente antes de fazer o teste! Somente aqueles com as pontuações mais altas terão a chance de ser convidados para o FAM.</span>',
    fastTrackButton: 'Clique aqui para fazer o teste Swiss Superstar',
    grading: 'Sua nota final é: {grade}%',
    badge: 'download \n crachá',
    fastTrackText: {
      success:
        'Parabéns, você foi aprovado no curso Fast Track e desbloqueou o restante do treinamento!',
      failed:
        'Infelizmente, você não foi aprovado no curso Fast Track, mas pode retomar seu treinamento para obter seu diploma!',
    },
  },
  nav: {
    home: 'Início',
    train: 'Trem',
    learn: 'Aprender',
    retain: 'Retenção',
    directory: 'Diretório',
    showRoom: 'Vitrines',
    showcases: 'Vitrines',
    offers: 'Ofertas',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Informações',
    rewards: 'Recompensas',
    media: 'Mídia',
    favorites: 'Favoritos',
    contact: 'Conheça a equipe',
    reportCard: 'Ver Diploma',
    accountSettings: 'Configurações da conta',
    messages: 'Mensagens',
    search: 'Pesquisa',
  },
  contentHeaders: {
    train: 'Trem',
    retain: 'Retenção',
    subapps: '{program_name_short} Módulos de parceiros',
    maintrainings: 'A Fundação',
    subtrainings: 'Especializações',
  },
  pageDescriptions: {
    train: 'Eduque, envolva-se e torne-se um especialista.',
    showroom: '',
    retain:
      'Parabéns por ter concluído seu treinamento! Agora você desbloqueou seu recurso de referência para reter seu conhecimento especializado e viabilizar seus esforços de vendas. Use essa área para responder com competência a uma pergunta sobre um produto ou até mesmo como uma apresentação de vendas improvisada - a qualquer hora, em qualquer lugar e em qualquer dispositivo.',
    promote:
      'Compartilhe esses itens para despertar o interesse e iniciar uma conversa com clientes e prospects.',
    sell: 'Responda às perguntas dos clientes e feche a venda como um profissional com recursos profundos e suporte de vendas direcionado.',
    favorites: 'Confira seu conteúdo favorito pessoal',
    search: 'Examinar todo o conteúdo',
    subapps: '',
    maintrainings:
      'Conclua esses módulos essenciais para obter seu certificado.',
    subtrainings:
      'Aprimore seu jogo e ganhe um emblema para cada módulo de especialização abaixo.',
  },
  general: {
    chapter: 'Capítulo',
    next: 'Próximo',
    yes: 'Sim',
    no: 'Não',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar',
    page: 'Página',
    search: 'Pesquisa',
    logIn: 'Fazer login',
    logOut: 'Sair do sistema',
    viewItem: 'Exibir {type}',
    imageNotFound: 'Imagem não encontrada',
    noResultsFor: 'Não foram encontrados resultados para: {{query}}',
    noFavorites: 'Você ainda não tem nenhum favorito.',
    noMessages: 'Você ainda não recebeu nenhuma mensagem!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar tudo',
    connectionError: 'Erro de conexão',
    alreadyExists: 'Já existe',
    pageNotFound: 'Página 404 não encontrada!',
    oops: 'Uh oh...',
    overview: 'Retornar à visão geral',
    complete: 'Continuar',
    courseComplete: 'Capítulo completo!',
    chapterComplete: 'Capítulo concluído!',
    message: '{count} Mensagem',
    messagePlural: '{count} Mensagens',
    comingSoon: 'Em breve',
  },
  itemTypes: {
    image: 'Imagem',
    brochure: 'Coleção',
    layout: 'Layout',
    web: 'Site',
    pdf: 'PDF',
    carousel: 'Coleção',
  },
  questions: {
    dials: 'Gire os botões giratórios para corresponder à resposta',
    fitb: 'Preencha o(s) espaço(s) em branco',
    flip: 'Altere o número para corresponder à resposta',
    multipleChoice: 'Escolha a(s) resposta(s) correta(s)',
    slider: 'Escolha a resposta certa usando o controle deslizante',
    map: 'Responda à pergunta tocando no local correto no mapa',
    dropdown: 'Escolha...',
    true: 'Verdadeiro',
    false: 'Falso',
  },
  reportCard: {
    download: 'Baixar',
    email: 'E-mail',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'CONCORDO',
    optout: 'Opt-out',
    settings: 'Configurações de privacidade',
    message:
      'Você não nos informou nada sobre suas preferências de privacidade de dados! Tudo bem, mas gostaríamos de oferecer a você a melhor experiência de uso do Sales Companion.',
    disabled: 'Parece que você desativou o uso de cookies.',
    use: 'O {{appName}} requer o uso de cookies para oferecer a você a melhor experiência.',
    details: 'Para que os cookies são usados?',
    enable: 'Veja como ativar seus cookies {{here}}.',
    here: 'aqui',
  },
  notLoggedIn: {
    super: 'Você não está conectado',
    title: 'Você precisa estar conectado para visualizar este conteúdo',
    guest: 'Convidado',
  },
  demo: {
    message:
      'Este site é uma demonstração do produto final. No momento, ele está em desenvolvimento e não é um produto completo.',
    consent: 'Entendido!',
  },
  share: {
    header: 'Compartilhe este recurso em sua mídia social favorita!',
    download: 'Baixar',
  },
  sharing: {
    copyURL: 'Copiar link',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header:
      'Parece que você está tentando acessar o aplicativo {appName} de um dispositivo móvel',
    body: 'Para fazer o download desse programa, basta acessar sua loja de aplicativos e procurar por {appName} ou clicar em um dos botões abaixo',
    benefits: {
      1: 'Aprenda, promova e venda em qualquer lugar',
      2: 'Treinamento multimídia em vários dispositivos',
      3: 'Certificado de conclusão',
      4: 'Apresentações de vendas prontas',
      5: 'Materiais promocionais de alto impacto',
      6: 'Diretório de produtos em tempo real',
      7: 'Notícias e atualizações oportunas',
      header: 'Isso fornecerá a você:',
    },
  },
  directoryView: {
    search: 'Pesquisar...',
    amountOfResults: 'Quantidade de resultados:',
    filter: 'Filtro',
    filters: 'Filtros:',
    subFilter: 'Subfiltro',
    resetFilters: 'Redefinir filtros',
    showResults: 'Mostrar resultados',
    noResults:
      'Nenhum resultado encontrado. Tente fazer uma pesquisa diferente.',
    resetMap: 'Redefinir o mapa para o início >',
    viewNow: 'Veja agora >',
  },
  directory: {
    artsentertainment: 'Artes e entretenimento',
    conventionservices: 'Serviços de convenções',
    divingsnorkeling: 'Mergulho e mergulho com snorkel',
    film: 'Filme',
    hotels: 'Hotéis',
    lgbtgymsandspas: 'LGBT+: Academias e spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Onde se hospedar',
    multiculturaldining: 'Multicultural: Jantar',
    multiculturalnightlife: 'Multicultural: Vida noturna',
    nightlife: 'Vida noturna',
    petfriendly: 'Aceita animais de estimação',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Spas',
    sports: 'Esportes',
    transportation: 'Transporte',
    venues: 'Locais',
    waterways: 'Hidrovias',
    waystoplay: 'Formas de jogar',
    weddinglocations: 'Locais de casamento',
    weddingvendors: 'Fornecedores de casamentos',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'Eu sou um ...',
    brandAmbassador: 'Embaixador da marca',
    travelPro: 'Profissional de viagens',
  },
  rewards: {
    rewards: 'Recompensas',
    title: 'Bem-vindo ao Centro de Recompensas',
    subheader: 'Acompanhe e compartilhe envios de reservas e prêmios',
    subTitle:
      'Estamos dando a você a chance de ganhar prêmios por se tornar um especialista em nosso programa e reservar viagens para {destination_name}!',
    body: 'Reserve uma viagem para {destination_name} para ter a chance de ganhar! Insira suas reservas para se qualificar para ganhar uma Recompensa de Incentivo Introdutório de um E-gift Card de US$ 5 EUA/CAN.',
    item1:
      'Após sua primeira reserva confirmada de 4 noites ou mais (para uma reserva individual), para um mínimo de dois (2) passageiros, em um hotel/resort qualificado. (Os cruzeiros não se qualificam).',
    item2:
      'Oferta válida após a conclusão dos Módulos Essenciais do {program_name}.',
    link1: 'Você já reservou {destination_name}? ',
    link2: 'Se for o caso, envie sua reserva aqui.',
    button: 'Envie sua reserva',
    products: 'Mercado',
    viewAllBookings: 'Reservas',
    viewLeaderboard: 'Tabela de classificação',
    viewDashboard: 'Painel de controle de pontos',
    viewRewards: 'Visão geral',
    overview: {
      title:
        'Ganhe pontos e recompensas em dinheiro por seu treinamento, compartilhamento e reservas {client_name}.',
      grand: 'Recompensas em dinheiro para cada reserva de mais de 3 noites',
      grandPrize: 'US$ 50 por cada estadia de 3 a 5 noites',
      grandPrizeSecond: 'US$ 100 por cada 6+ noites de estadia',
      first: 'Prêmios mensais',
      firstPrize:
        'Chances de ganhar parte de US$ 500 para os consultores de viagem que reservarem o maior número de hóspedes para qualquer propriedade {client_name}.',
      second: 'Grandes prêmios',
      secondPrize:
        'Quartos, upgrades, FAMs de inspeção no local, brindes e muito mais para surpreender e encantar nossos valiosos consultores.',
      choosen: 'Mercado de resgate baseado em pontos',
      choosenPrize:
        'Use os pontos que você ganhar ao longo do caminho para TODAS as atividades, incluindo agendamento de envios, treinamento e compartilhamento de garantias com seus clientes.',
      valid:
        '*As reservas registradas são válidas somente após a conclusão da viagem do cliente.',
    },
    home: {
      entries: 'Entradas atuais',
      trainingAchievements: 'REALIZAÇÕES DE TREINAMENTO',
      trainingAchievementsText:
        'Acompanhe o progresso do seu treinamento, as certificações e o status das recompensas metálicas nesta página. Você também poderá fazer o download e compartilhar seu diploma, bem como todos os emblemas que tiver conquistado.',
      bookingContests: 'PAINEL DE RESERVAS',
      bookingContestsText:
        'Acompanhe e gerencie facilmente os envios de reservas atuais no Painel de Reservas. ',
      submitBooking: 'ENVIAR RESERVAS',
      submitBookingText:
        'É aqui que você enviará reservas para inclusão em concursos de reservas.',
      currentContest: 'CONCURSO ATUAL',
      currentContests: 'CONCURSOS ATUAIS',
      contestHeader: 'Ganhe prêmios em dinheiro nas reservas de cada mês!',
      contestPrizes:
        'Insira suas reservas de hotéis, serviços terrestres e aluguel de carros todos os meses para ter a chance de ganhar três grandes prêmios:',
      contestPrize1: 'Um (1) cartão-presente de US$ 250 ',
      contestPrize1Description:
        'será concedido ao consultor com o maior número de reservas/entradas* no mês',
      contestPrize2: 'Dois (2) cartões-presente de US$ 100 ',
      contestPrize2Description:
        'será concedido a dois consultores sortudos por meio de um sorteio aleatório',
      contestConditions:
        '*Será concedida uma (1) entrada para cada reserva qualificada:',
      contestLodging: 'Hospedagem: ',
      contestCondition1: 'As reservas devem ser de 3 noites ou mais',
      contestGroundServices: 'Serviços terrestres: ',
      contestCondition2:
        '3 serviços ou mais (por exemplo, Meet & Greet, traslado e passeios turísticos)',
      contestCarRental: 'Aluguel de carros: ',
      contestCondition3: 'deve ser de 3 dias ou mais',
      contestStartEarning: 'Comece a ganhar suas chances de ganhar ',
      contestEnterBookings: 'inserindo suas reservas ',
      contestNow: 'Agora!',
      contestSeeOther: 'Ver outros ',
      contestTerms: 'Termos e condições',
    },
    bookingRewardsView: {
      title: 'Mercado',
    },
    bookingsView: {
      title: 'Reservas',
    },
    leaderboardScreen: {
      title: 'PONTOS \n Tabela de classificação',
      earnedpts: 'MEUS PONTOS GANHOS:',
      pointsWall: 'RASTREADOR DOS 5 MELHORES PONTOS:',
      startEarning:
        'Comece agora a ganhar XPs e entre na tabela de classificação!',
      prizes: 'Prêmios',
      tAndC: 'Termos e condições aplicáveis*',
      pointsOverview: {
        title: 'Como ganhar pontos',
        booths: 'Visite as vitrines dos expositores',
        breakoutSessions:
          'Participe de sessões de discussão e destaques de destinos',
        trainingSessions: 'Concluir um capítulo de treinamento',
        adventureSpotlights: 'Dicas de viagem em família',
        share: 'Compartilhamento de conteúdo',
        shareMax: '(até {maxSharePoints} pontos)',
        shareInfo:
          'O compartilhamento é contabilizado ao compartilhar o conteúdo do estande no Twitter e no Facebook ou ao compartilhar o estande inteiro com colegas ou clientes.',
        viewVideo: 'Exibir vídeo',
      },
    },
    dashboardView: {
      title: 'Painel de controle de reservas',
      subtitle: 'Acompanhe e gerencie suas entradas de reserva aqui.',
      badge: 'Crachás',
      activity: 'Painel de controle de reservas',
      manage: 'Gerenciar reservas',
      manageSub:
        'Classifique usando os botões acima e clique em qualquer registro para gerenciar os detalhes do envio. Todas as inscrições pendentes serão verificadas em até 72 horas. ',
      noBookings: 'Não há registros para exibir.',
      state: {
        approvedEntries: 'Entradas aprovadas',
        pendingEntries: 'Entradas pendentes',
        declinedEntries: 'Entradas recusadas',
        viewAll: 'Ver tudo',
      },
    },
    bookingForm: {
      title: 'Formulário de envio de reserva',
      subTitle: 'Digite sua reserva:',
      required: '* Indica um campo obrigatório',
      email: 'E-mail do agente',
      agentFirstName: 'Primeiro nome do agente',
      agentLastName: 'Sobrenome do agente',
      company: 'Nome da empresa',
      iata: 'NÚMERO IATA/CLIA',
      stateProvince: 'Estado/Província',
      postalCode: 'CEP *',
      country: 'País',
      bookingNumber: 'Número de confirmação da reserva',
      numberOfGuests: 'Número de convidados adultos',
      bookingDate: 'Data da reserva',
      tourOperator: 'Operadora de turismo / Método de reserva',
      firstName: 'Primeiro nome',
      lastName: 'Sobrenome do convidado',
      accommodation: 'Resort/Hotel/Alojamento reservado',
      select: 'Selecione uma opção',
      wholesaler:
        'Nome do atacadista (se aplicável): se for uma reserva direta, digite NONE',
      arrivalDate: 'Data do check-in',
      departureDate: 'Data do check-out',
      lengthOfStay: 'Duração da estadia (em noites)',
      reservationNumber: 'Número da reserva',
      rooms: 'Número de quartos',
      stay: 'Duração da estadia (em noites)',
      airline: 'Companhia aérea/transportadora (código de dois dígitos)',
      originAirport: 'Gateway de origem (código de 3 letras do aeroporto)',
      destination: 'Destino/ilha (código do aeroporto com três letras)',
      cost: 'Custo total da reserva (use apenas decimais)',
      file: 'RezSnap™ Proof Upload',
      disclaimer: '* Campos obrigatórios',
      button: 'Envie sua reserva',
      sub: 'Suas informações',
      sub2: 'Informações de reserva',
      guests: 'Número de passageiros',
    },
    termsConditions: {
      title: 'Termos e Condições',
      button: 'Voltar às Recompensas',
      textContent: {
        eligibilityDescription:
          'Apenas graduados do curso de {appName} são elegíveis e têm direito a participar, ganhar entradas e resgatar recompensas.',
        eligibilityRule:
          'O concurso de reservas é válido apenas para Consultores de Viagem, não para agências/grupos/empresas. A participação é individual e válida onde quer que você trabalhe ou possa trabalhar, enquanto este programa estiver em vigor.',
        qualifyingDescription:
          'Apenas Hospedagem e Serviços Terrestres, incluindo Aluguel de Carros, qualificam como reservas para ganhar entradas. Reservas de Voos e Cruzeiros não se qualificam.',
        fiscalResponsibilityRules: {
          1: 'Você deve se representar e agir como um consultor de viagens legítimo ou vendedor de viagens, membro da ASTA, ARC, IATA, CLIA, ou parte de uma Agência Anfitriã, Consórcio de Viagens, ou Conglomerado de Viagens devidamente licenciado sob as leis do seu país de residência e sujeito às leis dos Estados Unidos da América e às leis da Comunidade de {destinationName}.',
          2: 'Você é responsável por reportar qualquer receita de vendas às autoridades apropriadas do seu país, ou àquelas do país onde a viagem se originou. Os prêmios podem ou não estar isentos de acordo com as leis do seu país ou do passageiro onde a viagem se originou.',
          3: 'Outras condições podem se aplicar.',
          4: 'Este é um acordo de adesão. Os participantes aceitam os termos e condições do {clientName}, e todas as suas decisões como finais.',
          5: 'Qualquer deturpação dos participantes, o envio de informações falsas, ou qualquer ato considado má conduta resultará na perda da participação e todos os pontos ganhos, e pode arriscar responsabilidade por processo sob a lei.',
          6: 'Os participantes concordam que a lei prevalecente é a da Comunidade de {destinationName} para todos os propósitos relacionados a este programa.',
          7: 'Todos os termos e condições estão sujeitos a mudança sem aviso prévio.',
        },
        entrys: {
          1: 'Ganhe uma entrada para cada reserva de hospedagem de 3 noites ou mais.',
          2: 'Ganhe uma entrada para 3 ou mais Serviços Terrestres reservados (ex., Recepção e Transferência, transfer, turismo).',
          3: 'Ganhe uma entrada para cada reserva de Aluguel de Carro de 3 dias ou mais.',
          4: 'As reservas devem ser inseridas na página Enviar Reservas no Centro de Recompensas e podem ser rastreadas no Painel de Reservas.',
          5: 'Reservas válidas inseridas entre o primeiro e último dia do mês serão elegíveis para ganhar os prêmios em dinheiro mensais.',
          6: 'O consultor de viagens com o maior número de reservas qualificadas a cada mês será premiado com {span}.',
          7: 'Um sorteio aleatório de {span} será realizado no primeiro dia do mês ou próximo a ele para consultores de viagem que inserirem reservas qualificadas durante o mês anterior.',
          8: 'Todos os vencedores serão notificados e receberão seus cartões-presente por e-mail.',
          span: {
            6: 'um (1) Cartão-Presente de US$ 250',
            7: 'dois (2) Cartões-Presente de US$ 100',
          },
        },
      },
      sectionHeaders: {
        eligibility: 'Elegibilidade',
        conditions: 'Condições',
        fiscalResponsibility: 'Responsabilidade Fiscal',
      },
    },
    thankYouPage: {
      thanks: 'Muito obrigado',
      congrats: 'Parabéns, ',
      body: 'sua reserva foi recebida e enviada ao supervisor da campanha para verificação.',
      link: 'Observe que, para ser um vencedor, você deve ter concluído os Módulos Essenciais do Programa de Especialista em Bahamas',
    },
    menu: {
      home: 'Recompensas\nCentro',
      achievements: 'Treinamento\nConquistas',
      bookings: 'Reservas\nPainel de controle',
      form: 'Enviar\nReservas',
    },
  },
  badgeView: {
    title: 'Realizações de treinamento',
    subtitle:
      'Acompanhe o progresso do seu treinamento, as certificações e o status das recompensas metálicas nesta página. Você também poderá fazer o download e compartilhar seu diploma {program_name_short}, bem como todos os distintivos que tiver conquistado.',
    badgeDisplayTitle: 'Status de realização metálica',
    badgeAchievement:
      'Você alcançou o status {rank}! Clique no ícone à direita para visualizar e compartilhar seu status.',
    bronze: 'Bronze',
    silver: 'Prata',
    gold: 'Ouro',
    platinum: 'Platina',
    complete: 'COMPLETO',
    diploma: 'Diploma',
    chapterBadges: 'Emblemas de especialização',
    partnerBadges: 'Emblemas de parceiros',
  },
  badgeDisplay: {
    status: 'Status de realização do treinamento',
  },
  categories: {
    all: 'Todos',
    volunteeropportunities: 'Oportunidades de voluntariado',
    sportshobbiesactivities: {
      sportshobbiesactivities: 'Esportes, hobbies e atividades',
      scubadiving: 'Mergulho autônomo',
      snorkeling: 'Mergulho com snorkel',
      sup: 'SUP / Paddleboarding',
      fishing: 'Pesca',
      camping: 'Acampamento',
      trekkinghiking: 'Trekking e caminhadas',
      kayaking: 'Caiaque',
      riverrafting: 'Rafting no rio',
      rivertubing: 'Tubulação no rio',
      ziplining: 'Tirolesa',
      miniaturegolf: 'Miniatura de golfe',
      jetskiing: 'Jet Ski',
      otherwatersports: 'Outros esportes aquáticos',
      rappelling: 'Rapel',
      bowling: 'Boliche',
      recreationalwalking: 'Caminhada recreativa',
      surfinglessons: 'Aulas de surfe',
      golf: 'Golfe',
      biking: 'Ciclismo',
      bikingtrails: 'Trilhas para ciclismo',
      paintball: 'Paintball',
      fourwheeleratvs: 'Veículos com tração nas quatro rodas / ATVs',
      surfingequipment: 'Equipamento de surfe',
      horsebackriding: 'Passeios a cavalo',
      sailing: 'Vela',
      birding: 'Observação de pássaros',
      surfspots: 'Pontos de surfe',
      rockclimbing: 'Escalada em rocha',
      gokarts: 'Go-Karts',
      boatrentalscharters: 'Aluguel de barcos e fretamentos',
      cavetubing: 'Tubulação em cavernas',
      windsurfing: 'Windsurfe',
      kitesurfing: 'Kitesurfe / Kiteboarding',
      hanggliding: 'Asa Delta',
      scenicflights: 'Voos panorâmicos',
      parasailing: 'Parasailing',
      skydiving: 'Paraquedismo',
      balloonrides: 'Passeios de balão',
    },
    landmarkspointsofinterest: {
      landmarkspointsofinterest: 'Marcos e pontos de interesse',
      architecturalsites: 'Sites arquitetônicos',
      nationalregister:
        'Listagens do Registro Nacional de Lugares Históricos dos EUA',
      beaches: 'Praias',
      playgrounds: 'Playgrounds',
      townhalls: 'Prefeituras',
      housesofimportantfigures: 'Casas de personalidades importantes',
      photospotsviewpoints: 'Locais para fotos / pontos de vista',
      citytownplazas: 'Praças da cidade/bairro',
      ruinsabandonedplaces: 'Ruínas e lugares abandonados',
      fortresses: 'Fortalezas',
      historicwalkingareas: 'Áreas históricas para caminhadas',
      publicparks: 'Parques públicos',
      rivers: 'Rios',
      lakes: 'Lagos',
      archaeologicalsites: 'Sítios arqueológicos',
      lighthouses: 'Faróis',
      bays: 'Baías',
      churchesreligiouscenters: 'Igrejas e centros religiosos',
      libraries: 'Bibliotecas',
      statues: 'Estátuas',
      forests: 'Florestas',
      mountains: 'Montanhas',
      swimmingholes: 'Buracos para natação',
      boardwalks: 'Calçadões',
      naturalsprings: 'Fontes naturais',
      caves: 'Cavernas',
      indigenoussites: 'Locais indígenas',
      monuments: 'Monumentos',
      bioluminescentbays: 'Baías bioluminescentes',
      coffeeplantations: 'Plantações de café',
      murals: 'Murais',
      canyons: 'Canyons',
      inscribedrocks: 'Pedras inscritas',
      waterfalls: 'Cachoeiras',
      theaters: 'Teatros',
      universitiesschools: 'Universidades e escolas',
      visitorcenters: 'Centros de Visitantes',
      castles: 'Castelos',
      legendsghosts: 'Lendas e fantasmas',
      historicestates: 'Propriedades históricas',
      unescoheritagesites: 'Patrimônios da UNESCO',
      bridges: 'Pontes',
      islands: 'Ilhas',
      cays: 'Baías',
      marinasyachtclubs: 'Marinas / clubes náuticos',
      cemeteriesmausoleums: 'Cemitérios e Mausoléus',
      lagoons: 'Lagoas',
      reefs: 'Recifes',
      towers: 'Torres',
      gardens: 'Jardins',
      farms: 'Fazendas',
      fountains: 'Fontes',
      ranches: 'Fazendas',
      sculptures: 'Esculturas',
      dams: 'Barragens',
      caverns: 'Cavernas',
    },
    volunteeropportunities: {
      volunteeropportunities: 'Oportunidades de voluntariado',
      artsandculture: 'Artes e cultura',
      environment: 'Meio ambiente',
    },
    accommodations: {
      accommodations: 'Acomodações',
      bedandbreakfasts: 'Pousadas e cafés da manhã',
      condosandapartmentrentals: 'Aluguel de condomínios e apartamentos',
      smallinnsguesthouses: 'Pequenas pousadas e casas de hóspedes',
      housevillarentals: 'Aluguel de casas e vilas',
      hotels: 'Hotéis',
      resorts: 'Resorts',
      homestays: 'Casas de família',
      campgroundstentsites: 'Campings - Locais para barracas',
      campgroundstrailersites: 'Campings - Locais para trailers',
      hostelsbackpackers: 'Albergues / Mochileiros',
      uniquerentals: 'Aluguel exclusivo',
      glamping: 'Glamping',
      paradores: 'Paradores',
      motels: 'Motéis',
    },
    attractions: {
      attractions: 'Atrações',
      artgalleries: 'Galerias de arte',
      amusementparks: 'Parques de diversão',
      waterparks: 'Parques aquáticos',
      movietheaterscinemas: 'Cinemas / Cinemas',
      wildliferefugesnaturereserves:
        'Refúgios de vida selvagem e reservas naturais',
      thermalpools: 'Piscinas termais',
      nationalparks: 'Parques Nacionais',
      naturecenters: 'Centros de natureza',
      agritourism: 'Agriturismo',
      distilleries: 'Destilarias',
      casinos: 'Cassinos',
      eventticketing: 'Bilheteria de eventos',
      escaperooms: 'Salas de fuga',
      horseracing: 'Corrida de cavalos',
      botanicalgardens: 'Jardins Botânicos',
      danceshows: 'Shows de dança',
    },
    dining: {
      dining: 'Jantar',
      foodstands: 'Estandes de alimentos',
      chinchorros: 'Chinchorros',
      restaurants: 'Restaurantes',
      pubssportsbars: 'Pubs e bares esportivos',
      cafeterias: 'Cafeterias',
      bistrosloungesgastropubs: 'Bistrôs, Lounges e Gastropubs',
      bakeriespastryshops: 'Padarias / Confeitarias',
      coffeeshops: 'Cafeterias',
      foodtrucks: 'Caminhões de comida',
      specialtyfoodshops: 'Lojas de alimentos especiais',
      delis: 'Delis',
      breweries: 'Cervejarias',
      fastfood: 'Fast Food',
      diners: 'Jantares',
    },
    eventservices: {
      eventservices: 'Serviços de eventos',
      travelagencies: 'Agências de viagem',
      eventcoordinatorsmeetingplanners:
        'Coordenadores de eventos e planejadores de reuniões',
      eventmanagementcompanies: 'Empresas de gerenciamento de eventos',
      catering: 'Serviço de bufê',
      airfreightpackagesshipping: 'Frete aéreo, pacotes e remessas',
      groupfriendlyactivitiestours: 'Atividades e passeios para grupos',
      tourgroundoperatorscharters:
        'Operadoras de turismo e terrestres / Fretamentos',
      trainingteambuildingcompanies:
        'Empresas de treinamento e formação de equipes',
      weddingphotography: 'Fotografia de casamento',
      eventphotography: 'Fotografia de eventos',
      weddingplannerscoordinators: 'Planejadores e coordenadores de casamentos',
      musiciansentertainers: 'Músicos e artistas',
      healthspaswellnessprograms: 'Spas de saúde / Programas de bem-estar',
      flowersdecoration: 'Flores e decoração',
      linenchairtablerentals: 'Aluguel de roupa de cama, cadeiras e mesas',
      signsdisplaysgraphicsprinting: 'Sinais e displays / Gráficos / Impressão',
      workshopseminarspeakers: 'Palestrantes de workshops e seminários',
      audiovisual: 'Audiovisual',
      lightsoundeffects: 'Efeitos de luz e som',
      serviceprofessionals: 'Profissionais de serviços',
      hairmakeup: 'Cabelo e maquiagem',
      foreignlanguagespecialists: 'Especialistas em idiomas estrangeiros',
      promoitemsawardsgifts: 'Itens promocionais, prêmios e presentes',
      tempstaffingemploymentservices: 'Serviços de emprego e equipe temporária',
      groupfriendlyattractions: 'Atrações para grupos',
      destinationmanagementcompanies: 'Empresas de gerenciamento de destinos',
      musicentertainmentpromoters: 'Promotores de música e entretenimento',
      webcastinginternetservices: 'Webcasting e serviços de Internet',
      finepastries: 'Doces finos',
      expositiontradeshowcontractors:
        'Empreiteiros de exposições e feiras de negócios',
      travelwholesalers: 'Atacadistas de viagens',
      securitysystemcompanies: 'Empresas de sistemas de segurança',
      officesupplies: 'Material de escritório',
      computerrentaldataprocessingit:
        'Aluguel de computadores, processamento de dados e TI',
    },
    eventvenues: {
      eventvenues: 'Locais para eventos',
      accommodationonsite: 'Acomodação no local',
      meetingrooms: 'Salas de reunião',
      conferencecenters: 'Centros de conferência',
      groupdiningvenues: 'Locais para refeições em grupo',
      noaccommodationonsite: 'Sem acomodação no local',
      ceremonyvenues: 'Locais de cerimônia',
      receptionvenues: 'Locais de recepção',
      conventioncenters: 'Centros de convenções',
      ballrooms: 'Salões de festas',
      banquetvenues: 'Locais para banquetes',
      theatershowvenues: 'Locais de teatro / shows',
      concertvenues: 'Locais de shows',
      stadiums: 'Estádios',
    },
    medicaltourism: {
      medicaltourism: 'Turismo médico',
      dental: 'Odontológico',
      hospitals: 'Hospitais',
    },
    museums: {
      museums: 'Museus',
      historymuseums: 'Museus de história',
      artmuseums: 'Museus de arte',
      sciencemuseums: 'Museus de Ciências',
      archaeologymuseums: 'Museus de Arqueologia',
      agriculturemuseums: 'Museus de agricultura',
      musicmuseums: 'Museus de música',
      folkloreindigenousmuseums: 'Museus de folclore e indígenas',
    },
    nightlife: {
      nightlife: 'Vida noturna',
      danceclubs: 'Clubes de dança',
      karaoke: 'Karaokê',
      sportsbars: 'Bares esportivos',
      comedyclubs: 'Clubes de comédia',
      livemusic: 'Música ao vivo',
      lounges: 'Lounges',
      cocktailbars: 'Bares de coquetéis',
      cigarbars: 'Bares de charutos',
      speakeasies: 'Casas de espetáculo',
      gaybars: 'Bares gays',
      winebars: 'Bares de vinho',
    },
    shopping: {
      shopping: 'Compras',
      clothingstores: 'Lojas de roupas',
      specialtyshops: 'Lojas especializadas',
      sportsoutdoorsoutfitters: 'Esportes / Ar Livre Outfitters',
      giftshops: 'Lojas de presentes',
      shoppingcentersplazas: 'Shopping centers / praças',
      artsandcrafts: 'Artes e artesanato',
      madeinpuertorico: 'Fabricado em {destination_name}',
      grocerystores: 'Mercearias',
      malls: 'Shoppings',
      jewelrystores: 'Joalherias',
      departmentstores: 'Lojas de departamento',
      fleamarkets: 'Mercados de pulgas',
      openairmarkets: 'Mercados a céu aberto',
      boutiques: 'Boutiques',
      farmersmarkets: 'Mercados de produtores rurais',
      outlets: 'Pontos de venda',
    },
    sportsmarketing: {
      sportsmarketing: 'Marketing esportivo',
      associationsfederations: 'Associações e Federações',
      baseballvenues: 'Locais de beisebol',
      basketballvenues: 'Locais de basquete',
      swimmingvenues: 'Locais de natação',
      tennisvenues: 'Locais de tênis',
      trackandfieldvenues: 'Locais de pista e campo',
      volleyballvenues: 'Locais de vôlei',
      soccerfootballvenues: 'Locais de futebol / futebol americano',
      golfvenues: 'Locais de golfe',
      softballvenues: 'Locais de Softball',
      fishingtournamentvenues: 'Locais de torneios de pesca',
      martialartsvenues: 'Locais de artes marciais',
      skateboardingvenues: 'Locais para prática de skate',
      sportspromoters: 'Promotores esportivos',
    },
    tours: {
      tours: 'Passeios',
      adventuretours: 'Passeios de aventura',
      guidedtours: 'Visitas guiadas',
      boattours: 'Passeios de barco',
      cavetours: 'Passeios em cavernas',
      natureecotours: 'Natureza e passeios ecológicos',
      sightseeingtours: 'Passeios turísticos',
      studentyouthtours: 'Passeios para estudantes e jovens',
      culturaltours: 'Passeios culturais',
      biketours: 'Passeios de bicicleta',
      historicaltours: 'Passeios históricos',
      foodtours: 'Passeios gastronômicos',
      walkingtours: 'Passeios a pé',
      agriculturaltours: 'Passeios agrícolas',
      shoppingtours: 'Passeios de compras',
      nighttours: 'Passeios noturnos',
      drivingtours: 'Passeios de carro',
      distillerytours: 'Passeios em destilarias',
      bustrolleytours: 'Passeios de ônibus e trólebus',
      motorcycletours: 'Passeios de motocicleta',
    },
    transportation: {
      transportation: 'Transporte',
      airports: 'Aeroportos',
      airlines: 'Companhias aéreas',
      buses: 'Ônibus',
      luxurytransportation: 'Transporte de luxo',
      privatetransportation: 'Transporte particular',
      carvanrentals: 'Aluguel de carro / van',
      aircraftchartershelicopter: 'Fretamento de aeronaves - Helicóptero',
      taxis: 'Táxis',
    },
    wellness: {
      wellness: 'Bem-estar',
      gymsfitnesscenters: 'Academias e centros de fitness',
      yoga: 'Ioga',
      spas: 'Spas',
      meditation: 'Meditação',
    },
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
